import React from "react";
import Header from "../components/HeaderThree";
import "../styles/PrivacyPolicyPage.css";

export default function PrivacyPolicyPage() {
  return (
    <>
      <Header />

      <main className="privacy-page">
        <section className="privacy-container">
          <h1 className="privacy-title">Privacy Policy</h1>

          <div className="privacy-block">
            <p>
              As a general rule, this website does not collect Personal Information about you when you visit the site.
              You can generally visit the site without revealing Personal Information, unless you choose to provide
              such information.
            </p>
          </div>

          <div className="privacy-block">
            <h2>Site Visit Data</h2>
            <p>
              This website records your visit and logs the following information for statistical purposes your server&apos;s
              address; the name of the top-level domain from which you access the Internet (for example, .gov, .com,
              .in, etc.); the type of browser you use; the date and time you access the site; the pages you have
              accessed and the documents downloaded and the previous Internet address from which you linked directly to
              the site. We will not identify users or their browsing activities, except when a law enforcement agency
              may exercise a warrant to inspect the service provider&apos;s logs.
            </p>
          </div>

          <div className="privacy-block">
            <h2>Cookies</h2>
            <p>
              A cookie is a piece of software code that an internet web site sends to your browser when you access the
              information at that site. This site does not use cookies.
            </p>
          </div>

          <div className="privacy-block">
            <h2>Collection of Personal Information</h2>
            <p>
              If you are asked for any other Personal Information you will be informed how it will be used if you
              choose to give it. If at any time you believe the principles referred to in this privacy statement have
              not been followed, or have any other comments on these principles, please notify the webmaster through
              the contact us page.
            </p>
          </div>

          <div className="privacy-block">
            <h2>Note</h2>
            <p>
              The use of the term &quot;Personal Information&quot; in this privacy statement refers to any information from which
              your identity is apparent or can be reasonably ascertained.
            </p>
            <p>
              At many places in this website, you shall find links to other websites/portals. This links have been
              placed for your convenience. Vessella Group is not responsible for the contents and reliability of the
              linked websites and does not necessarily endorse the views expressed in them. Mere presence of the link
              or its listing on this website should not be assumed as endorsement of any kind. We cannot guarantee that
              these links will work all the time and we have no control over availability of linked pages.
            </p>
          </div>

          <div className="privacy-block">
            <h2>Links to Vessella Group Website by Other Websites / Portals</h2>
            <p>
              Prior permission is required before hyperlink are directed from any website/portal to this site.
              Permission for the same, stating the nature of the content on the pages from where the link has to be
              given and the exact language of the hyperlink should be obtained by sending a request to stake holder.
            </p>
          </div>
        </section>
      </main>
    </>
  );
}
